import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function AdminRoute({ children }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const token = sessionStorage.getItem('admin_token');

    // No token = not logged in. Redirect immediately, no server call needed.
    if (!token) {
      setStatus('denied');
      return;
    }

    // Token exists — verify it's still valid with the server
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch('/api/admin/auth/check', {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        if (!cancelled) {
          if (res.ok) {
            setStatus('ok');
          } else {
            // Token expired/invalid — clear it and redirect
            sessionStorage.removeItem('admin_token');
            setStatus('denied');
          }
        }
      } catch {
        if (!cancelled) {
          sessionStorage.removeItem('admin_token');
          setStatus('denied');
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (status === 'denied') {
      navigate('/admin/login', { replace: true });
    }
  }, [status, navigate]);

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <div className="w-10 h-10 border-3 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status !== 'ok') return null;

  return children;
}
